<template>
  <div>
    <app-header></app-header>
    <main>
      <news-organization :district-id="districtId"></news-organization>
    </main>
  </div>
</template>

<script>
  import AppHeader from '../components/Header.component'
  import NewsOrganization from '../components/NewsOrganization.component'

  export default {
    name: 'news-organization-page',
    components: {
      AppHeader,
      NewsOrganization
    },

    props: {
      districtId: {
        type: String,
        default: null
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";
  
  main {
    margin-top: $header-height;
  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsOrganization.page.vue